<div class="industry-select-container"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut()">
  <mat-select
    [(value)]="selectedIndustryCodes"
    (selectionChange)="onIndustrySelectionChange()"
    [placeholder]="placeholder"
    [multiple]="allowMultiple"
    [disabled]="disabled"
    [required]="required"
    class="custom-select-field-value">

    <!-- Search box at the top of the dropdown -->
    <div class="search-header full-width" (click)="$event.stopPropagation()">
      <mat-form-field class="custom-text-field full-width-i" appearance="outline">
        <input matInput
               [formControl]="searchControl"
               placeholder="Search categories and industries..."
               (click)="$event.stopPropagation()">
        <mat-icon matPrefix>search</mat-icon>
        <button mat-icon-button matSuffix
                *ngIf="searchControl.value"
                (click)="clearSearch(); $event.stopPropagation()"
                type="button">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Categories and Industries -->
    <mat-optgroup *ngFor="let category of filteredIndustries" class="btn-cursor">
      <!-- Category Header with Select All Checkbox -->
      <mat-label (click)="toggleCategory(category, $event)"
                 class="custom-select-field-section full-width"
                 fxLayout="row"
                 fxLayoutAlign="start center"
                 fxLayoutGap="8px"
                 [style.pointer-events]="allowMultiple ? 'auto' : 'none'"
                 [class.btn-cursor]="allowMultiple">
        <mat-checkbox
          *ngIf="allowMultiple"
          [checked]="isCategoryFullySelected(category)"
          [indeterminate]="isCategoryPartiallySelected(category)"
          (click)="$event.stopPropagation()"
          (change)="toggleCategory(category, $event)"
          color="primary">
        </mat-checkbox>
        <span class="subheading-default text-uppercase font-weight-600">{{ category.name }}</span>
        <span *ngIf="allowMultiple"
              class="category-count">
          ({{ category.industries.length || 0 }})
        </span>
      </mat-label>

      <!-- Industry Options -->
      <mat-option
        *ngFor="let industry of category.industries"
        [value]="industry.code"
        class="custom-select-field-option">
          {{ industry.name }}
      </mat-option>
    </mat-optgroup>

    <!-- No Results -->
    <mat-option *ngIf="filteredIndustries.length === 0"
                [disabled]="true"
                class="no-results-option">
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
        <mat-icon>search_off</mat-icon>
        <span>No industries found</span>
      </div>
    </mat-option>
  </mat-select>
</div>
